import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from './endpoints';
import { UserWireData, Person } from 'app/components/access-panel/shared/types';
import { ApiResponse } from 'app/types-shared';

export const api = {
  getDefaultValues: () => {
    return new RemoteData(endpoint.loadDefaultValues)
      .resource<ApiResponse<UserWireData>>()
      .single();
  },

  getRole: () => {
    return new RemoteData(endpoint.roleData)
      .resource<ApiResponse<Person>>()
      .single();
  },

  saveDefaultValues: async (user: any) => {
    return new RemoteData(endpoint.saveDefaultValues)
      .resource<ApiResponse<any>>()
      .save(user);
  }
};
